import React, {useContext} from "react";
import {WizardContext} from "../Wizard";
import {WizardFormTextarea} from "../wizardFormType/WizardFormTextarea";
import {WizardFormFile} from "../wizardFormType/WizardFormFile";

export function WizardFormDesign() {
    const { keyData,form } = useContext(WizardContext);

    return (
        <div className="pb-5" data-wizard-type="step-content" data-wizard-state="current">
            <h3 className="mb-5 font-weight-bold text-dark">디자인 참고사항</h3>
            <WizardFormFile data={keyData && keyData.order_reference}/>
            <WizardFormTextarea data={keyData && keyData.order_reference} form={form}/>
        </div>
    )
}